const { accountNo } = require('./account-no')
const { age } = require('./age')
const { bank } = require('./bank')
const { date } = require('./date')
const { digits } = require('./digits')
const { futureDate } = require('./future-date')
const { hasDebts } = require('./has-debts')
const { match } = require('./match')
const { maxDate } = require('./max-date')
const { maxLength } = require('./max-length')
const { maxValue } = require('./max-value')
const { minDate } = require('./min-date')
const { minLength } = require('./min-length')
const { minValue } = require('./min-value')
const { noMatch } = require('./no-match')
const { noOnlyDigits } = require('./no-only-digits')
const { noSingleMaritalStatuses } = require('./no-single-marital-statuses')
const { pastDate } = require('./past-date')
const { regex } = require('./regex')
const { requireTrue } = require('./require-true')
const { required } = require('./required')
const { uniqueSsn } = require('./unique-ssn')
const { iban } = require('./iban')
const { ssn } = require('./ssn')
const { citizenship } = require('./citizenship')
const { otherDebtType } = require('./other-debt-type')
const { phone } = require('./phone')
const { businessId } = require('./business-id')

module.exports = {
  accountNo,
  age,
  bank,
  date,
  digits,
  futureDate,
  hasDebts,
  match,
  maxDate,
  maxLength,
  maxValue,
  minDate,
  minLength,
  minValue,
  noMatch,
  noOnlyDigits,
  noSingleMaritalStatuses,
  pastDate,
  regex,
  requireTrue,
  required,
  uniqueSsn,
  iban,
  ssn,
  citizenship,
  otherDebtType,
  phone,
  businessId
}
